// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.development-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.development-section .development-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.development-section .development-wrap .development-box .cards-grid {
  --cards-grid-number: 3;
  --cards-grid-gap: 2rem;
  display: grid;
  grid-template-columns: repeat(var(--cards-grid-number), 1fr);
  gap: var(--cards-grid-gap);
}
.development-section .development-wrap .development-box .development-card {
  width: 100%;
  height: 100%;
  border: 1px solid var(--quickSilver-1000);
  border-radius: 1.25rem;
  padding: 0.75rem;
}
.development-section .development-wrap .development-box .development-card .development-card-header {
  width: 100%;
  background-color: var(--primaryMain-1000);
  border-radius: 0.75rem;
  padding: 1rem;
}
.development-section .development-wrap .development-box .development-card .development-card-header .title-text {
  color: var(--white-1000);
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
}
.development-section .development-wrap .development-box .development-card .development-card-body {
  padding: 2rem 1rem;
}
.development-section .development-wrap .development-box .development-card .development-card-body .subtitle-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.4;
}
.development-section .development-wrap .development-box .development-card .development-card-body .list-text-box {
  padding-left: 1.75rem;
  margin-top: 1.25rem;
}
.development-section .development-wrap .development-box .development-card .development-card-body .list-text-box .list-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
}
.development-section .development-wrap .development-box .development-card .development-card-body .list-text-box .list-text:not(:last-child) {
  margin-bottom: 0.25rem;
}
.development-section .development-wrap .development-box .btn-box {
  display: flex;
  justify-content: center;
  margin-top: 4rem;
}
@media screen and (max-width: 991.98px) {
  .development-section {
    padding: 2.5rem 0;
  }
  .development-section .development-wrap .development-box .cards-grid {
    --cards-grid-number: 2;
    --cards-grid-gap: 1.25rem;
  }
  .development-section .development-wrap .development-box .development-card {
    border-radius: 1rem;
    padding: 0.5rem;
  }
  .development-section .development-wrap .development-box .development-card .development-card-header {
    border-radius: 0.625rem;
    padding: 1rem;
  }
  .development-section .development-wrap .development-box .development-card .development-card-header .title-text {
    font-size: 1rem;
  }
  .development-section .development-wrap .development-box .development-card .development-card-body {
    padding: 1.25rem 0.75rem;
  }
  .development-section .development-wrap .development-box .development-card .development-card-body .subtitle-text {
    font-size: 1rem;
  }
  .development-section .development-wrap .development-box .development-card .development-card-body .list-text-box {
    padding-left: 1.25rem;
    margin-top: 1rem;
  }
  .development-section .development-wrap .development-box .development-card .development-card-body .list-text-box .list-text {
    font-size: 1rem;
  }
  .development-section .development-wrap .development-box .btn-box {
    margin-top: 2.5rem;
  }
}
@media screen and (max-width: 767.98px) {
  .development-section {
    padding: 2rem 0;
  }
  .development-section .development-wrap .development-box .cards-grid {
    --cards-grid-number: 2;
    --cards-grid-gap: 1rem;
  }
  .development-section .development-wrap .development-box .development-card .development-card-header {
    border-radius: 0.5rem;
    padding: 0.5rem 1rem;
  }
  .development-section .development-wrap .development-box .development-card .development-card-header .title-text {
    font-size: 0.875rem;
  }
  .development-section .development-wrap .development-box .development-card .development-card-body {
    padding: 0.75rem 0.75rem;
  }
  .development-section .development-wrap .development-box .development-card .development-card-body .subtitle-text {
    font-size: 0.875rem;
  }
  .development-section .development-wrap .development-box .development-card .development-card-body .list-text-box {
    padding-left: 1.25rem;
    margin-top: 0.75rem;
  }
  .development-section .development-wrap .development-box .development-card .development-card-body .list-text-box .list-text {
    font-size: 0.875rem;
  }
  .development-section .development-wrap .development-box .btn-box {
    margin-top: 1.25rem;
  }
}
@media screen and (max-width: 639.98px) {
  .development-section {
    padding: 2rem 0;
  }
  .development-section .development-wrap .development-box .cards-grid {
    --cards-grid-number: 1;
    --cards-grid-gap: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DevelopmentSection/DevelopmentStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AAEM;EACE,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,4DAAA;EACA,0BAAA;AAAR;AAGM;EACE,WAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;EACA,gBAAA;AADR;AAGQ;EACE,WAAA;EACA,yCAAA;EACA,sBAAA;EACA,aAAA;AADV;AAGU;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AADZ;AAKQ;EACE,kBAAA;AAHV;AAKU;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAHZ;AAMU;EACE,qBAAA;EACA,mBAAA;AAJZ;AAMY;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAJd;AAMc;EACE,sBAAA;AAJhB;AAWM;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AATR;AAcE;EA5EF;IA6EI,iBAAA;EAXF;EAeM;IACE,sBAAA;IACA,yBAAA;EAbR;EAgBM;IACE,mBAAA;IACA,eAAA;EAdR;EAgBQ;IACE,uBAAA;IACA,aAAA;EAdV;EAgBU;IACE,eAAA;EAdZ;EAkBQ;IACE,wBAAA;EAhBV;EAkBU;IACE,eAAA;EAhBZ;EAmBU;IACE,qBAAA;IACA,gBAAA;EAjBZ;EAmBY;IACE,eAAA;EAjBd;EAuBM;IACE,kBAAA;EArBR;AACF;AA0BE;EA5HF;IA6HI,eAAA;EAvBF;EA2BM;IACE,sBAAA;IACA,sBAAA;EAzBR;EA6BQ;IACE,qBAAA;IACA,oBAAA;EA3BV;EA6BU;IACE,mBAAA;EA3BZ;EA+BQ;IACE,wBAAA;EA7BV;EA+BU;IACE,mBAAA;EA7BZ;EAgCU;IACE,qBAAA;IACA,mBAAA;EA9BZ;EAgCY;IACE,mBAAA;EA9Bd;EAoCM;IACE,mBAAA;EAlCR;AACF;AAuCE;EAzKF;IA0KI,eAAA;EApCF;EAwCM;IACE,sBAAA;IACA,sBAAA;EAtCR;AACF","sourcesContent":[".development-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .development-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .development-box {\n      .cards-grid {\n        --cards-grid-number: 3;\n        --cards-grid-gap: 2rem;\n        display: grid;\n        grid-template-columns: repeat(var(--cards-grid-number), 1fr);\n        gap: var(--cards-grid-gap);\n      }\n\n      .development-card {\n        width: 100%;\n        height: 100%;\n        border: 1px solid var(--quickSilver-1000);\n        border-radius: 1.25rem;\n        padding: 0.75rem;\n      \n        .development-card-header {\n          width: 100%;\n          background-color: var(--primaryMain-1000);\n          border-radius: 0.75rem;\n          padding: 1rem;\n\n          .title-text {\n            color: var(--white-1000);\n            font-size: 1.5rem;\n            font-weight: 700;\n            line-height: 1.4;\n            text-align: center;\n          }\n        }\n\n        .development-card-body {\n          padding: 2rem 1rem;\n\n          .subtitle-text {\n            color: var(--black-1000);\n            font-size: 1.5rem;\n            font-weight: 700;\n            line-height: 1.4;\n          }\n          \n          .list-text-box {\n            padding-left: 1.75rem;\n            margin-top: 1.25rem;\n\n            .list-text {\n              color: var(--black-1000);\n              font-size: 1.5rem;\n              font-weight: 400;\n              line-height: 1.4;\n\n              &:not(:last-child) {\n                margin-bottom: 0.25rem;\n              }\n            }\n          }\n        }\n      }\n\n      .btn-box {\n        display: flex;\n        justify-content: center;\n        margin-top: 4rem;\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .development-wrap {  \n      .development-box {\n        .cards-grid {\n          --cards-grid-number: 2;\n          --cards-grid-gap: 1.25rem;\n        }\n  \n        .development-card {\n          border-radius: 1rem;\n          padding: 0.5rem;\n        \n          .development-card-header {\n            border-radius: 0.625rem;\n            padding: 1rem;\n  \n            .title-text {\n              font-size: 1rem;\n            }\n          }\n  \n          .development-card-body {\n            padding: 1.25rem 0.75rem;\n  \n            .subtitle-text {\n              font-size: 1rem;\n            }\n            \n            .list-text-box {\n              padding-left: 1.25rem;\n              margin-top: 1rem;\n  \n              .list-text {\n                font-size: 1rem;\n              }\n            }\n          }\n        }\n  \n        .btn-box {\n          margin-top: 2.5rem;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .development-wrap {  \n      .development-box {\n        .cards-grid {\n          --cards-grid-number: 2;\n          --cards-grid-gap: 1rem;\n        }\n  \n        .development-card {        \n          .development-card-header { \n            border-radius: 0.5rem;\n            padding: 0.5rem 1rem;\n\n            .title-text {\n              font-size: 0.875rem;\n            }\n          }\n  \n          .development-card-body {\n            padding: 0.75rem 0.75rem;\n  \n            .subtitle-text {\n              font-size: 0.875rem;\n            }\n            \n            .list-text-box {\n              padding-left: 1.25rem;\n              margin-top: 0.75rem;\n  \n              .list-text {\n                font-size: 0.875rem;\n              }\n            }\n          }\n        }\n  \n        .btn-box {\n          margin-top: 1.25rem;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 639.98px) {\n    padding: 2rem 0;\n\n    .development-wrap {  \n      .development-box {\n        .cards-grid {\n          --cards-grid-number: 1;\n          --cards-grid-gap: 1rem;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
